<template>
    <div class="cartpreview item" data-type="cart">
        <div v-if="cart" v-on:mouseover="setExpanding(true)" v-on:mouseleave="setExpanding(false)">
            <div class="item">
                <button class="button" v-if="cart" data-type="hover" aria-label="Carrello">
                    <div :data-notify="cart.cartQuantity > 0">
                        <span class="icon fastic-cart" role="none"></span>
                        <span class="notify" v-if="cart.cartQuantity > 0">{{ cart.cartQuantity }}</span>
                    </div>
                </button>
                <a :href="routes.Cart_Detail" class="button" data-type="link" v-if="cart">
                    <div :data-notify="cart.cartQuantity > 0">
                        <span class="icon fastic-cart"></span>
                        <span class="notify" v-if="cart.cartQuantity > 0">{{ cart.cartQuantity }}</span>
                    </div>
                </a>
            </div>
            <div :class="setExpandingClass()" v-if="cart">
                <section class="list-items" v-if="cart.cartQuantity > 0">
                    <div class="rows">
                        <article class="item" v-for="cartRow in cart.cartRows">
                            <div class="image">
                                <div v-if="cartRow.productImageUrl"><img :src="cartRow.productImageUrl" width="100" height="100" alt="" loading="lazy" /></div>
                                <div v-else class="noimg">
                                    <div class="icon fa fa-camera-retro"></div>
                                    <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" width="1" height="1" />
                                </div>
                            </div>
                            <div class="desc">
                                <div class="title">{{ cartRow.productTitle }}</div>
                                <div class="variant"><span class="label">{{ cartRow.variantTitle }}</span>{{ cartRow.variantDescription }}</div>
                                <div class="cod">{{ localizer.get("Checkout.Common.Cod") }} {{ cartRow.productCode }}</div>
                                <div class="qty">{{ localizer.get("Checkout.Common.Quantity") }}: <strong>{{ cartRow.quantity }}</strong></div>
                                <div class="price"><span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span> {{ cartRow.rowPrice }}</div>
                            </div>
                        </article>
                    </div>
                    <footer class="footer">
                        <div class="discount" v-if="cart.couponCode">
                            {{ localizer.get("Checkout.Common.Discount") }}:
                            <span v-if="cart.couponDiscountMode === 'Amount'">
                                <span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span>-{{ formatPrice(cart.couponDiscount) }}
                            </span>
                            <span v-if="cart.couponDiscountMode === 'Percentage'">
                                -{{ cart.couponDiscount }}<span class="unit">%</span>
                            </span>
                            <div class="discount-alert" v-if="cart.CouponMinimumGap">{{ localizer.get("Checkout.Common.CouponGap_Start") }} {{ formatPrice(cart.couponMinimumGap) }} {{ localizer.get("Checkout.Common.CouponGap_End") }}</div>
                        </div>
                        <div class="checkout">
                            <div class="link"><a :href="routes.Cart_Detail" class="no-uline" @click="goToCart()"><span class="icon fastic-cart"></span><span class="txt">{{ localizer.get("Checkout.Common.GoToCart") }}</span></a></div>
                            <div class="total">
                                <span class="label">{{ localizer.get("Checkout.Common.TotalIva") }}</span>
                                <span class="price"><span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span><span class="value">{{ cart.cartTotal }}</span></span>
                            </div>
                        </div>
                        <div class="minimumtotal" v-if="cart.minimumTotalGap">{{ localizer.get("Checkout.Common.MinimumTotal") }} {{ cart.minimumTotal }}</div>
                        <div class="minimumtotalgap" v-if="cart.minimumTotalGap">{{ localizer.get("Checkout.Common.MinimumTotalGap_Start") }} {{ cart.minimumTotalGap }} {{ localizer.get("Checkout.Common.MinimumTotalGap_End") }}</div>

                        <template v-if="cart.shippingMode != 'ExWork'">
                            <div class="minimumtotalgap" v-if="!cart.freeShippingGap">{{ localizer.get("Checkout.Common.FreeShipping") }}</div>
                        </template>
                        <div class="calltoaction"><a :href="routes.Checkout_Summary" class="button" @click="openCompleteOrder()">{{ localizer.get("Checkout.Common.CompleteOrder") }}</a></div>
                    </footer>
                </section>
                <div class="notfound" v-else>
                    <div class="title">{{ localizer.get("Checkout.Common.Empty_Title") }}</div>
                    <div class="desc">
                        <span v-html="localizer.get('Checkout.Common.Empty_Description', routes.Account_Login, localizer.get('Checkout.Common.Empty_Link'))"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

const store = useStore();

const localizer = Localizer;
const routes = (window as any).App.routes;

const cart = computed(() => {
    return store.getters["cartStore/cart"];
});

const isCartPreviewVisible = computed(() => {
    return store.getters["cartStore/isCartPreviewVisible"];
});

function setExpanding(isVisible: boolean) {
    store.commit("cartStore/setIsCartPreviewVisible", isVisible);
}

function setExpandingClass() {
    return isCartPreviewVisible.value ? "exp show" : "exp";
}

function formatPrice(data: any) {
    return Number(data).toFixed(2).replace(".", ",");
}

function openCompleteOrder() {
    GTagHelper.sendEvent("click", "complete_order", "");
}

function goToCart() {
    GTagHelper.sendEvent("click", "go_to_cart", "");
}
</script>